import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExternalEoiGenerateModalModule } from '@common/external-eoi-generate-modal/external-eoi-generate-modal.module';
import { ExternalEoiLinksModule } from '@common/external-eoi-links/external-eoi-links.module';
import { GenaricNotesModule } from '@common/notes/notes.module';
import { HistoryModule } from '@common/remmi-history/history.module';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { GoogleAddressModule } from '@directive/google-address/google-address.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ReorderPipeModule } from '@pipes/reorder-pipe/reorder.module';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { CreateTaskModule } from '../../my-tasks/create-new-task/create-task.module';
import { EditTaskModule } from '../../my-tasks/edit-task/edit-task.module';
import { LeadPrimeNgModule } from '../Lead-primeNg.module';
import { EditLeadDetailComponent } from './edit-lead-detail.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { EditLeadAppointmentComponent } from './edit-lead-appointment/edit-lead-appointment.component';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MenuModule } from 'primeng/menu';
import { AmTimeAgoModule } from '@pipes/time-ago/am-time-ago.module';
import { MobileFormatPipeModule } from '@pipes/mobile-format/mobile-format.module';
import { PossibleDuplicateContactModule } from '@modules/contact/possible-duplicate-contact/possible-duplicate-contact.module';
import { LinkedContactSummaryModule } from '@modules/contact/linked-contact-summary/linked-contact-summary.module';
import { HelpLeadsUiModule } from '../../help-system/help-leads-ui.module';
import { FollowUpOptionsEditorComponent } from './lead-follow-up-popover/follow-up-options-editor/follow-up-options-editor.component';
import { LeadFollowUpPopoverComponent } from './lead-follow-up-popover/lead-follow-up-popover.component';
import { LeadReportNotesSummaryComponent } from './lead-report-notes-summary/lead-report-notes-summary.component';
import { LeadHorizonTrackingComponent } from '../lead-horizon-tracking/lead-horizon-tracking.component';
import { HorizonHeatMapComponent } from '@common/horizon-heat-map/horizon-heat-map.component';
import { HorizonMatrixHeatmapComponent } from '../lead-horizon-tracking/horizon-matrix-heatmap/horizon-matrix-heatmap.component';
import { HorizonBuyerInsightsComponent } from '../lead-horizon-tracking/horizon-buyer-insights/horizon-buyer-insights.component';
import { HorizonSharedWithBuyerComponent } from '../lead-horizon-tracking/horizon-shared-with-buyer/horizon-shared-with-buyer.component';
import { HorizonBuyerPreferencesComponent } from '../lead-horizon-tracking/horizon-buyer-preferences/horizon-buyer-preferences.component';
import { DuplicateLeadMergeModule } from '../duplicate-lead-merge/duplicate-lead-merge.module';
import { NoResponseBlockedDialogComponent } from './no-response-blocked-dialog/no-response-blocked-dialog.component';
import { CloseSuggestionBannerComponent } from './close-suggestion-banner/close-suggestion-banner.component';

@NgModule({
  declarations: [
    EditLeadDetailComponent,
    EditLeadAppointmentComponent,
    LeadFollowUpPopoverComponent,
    FollowUpOptionsEditorComponent,
    LeadReportNotesSummaryComponent,
    LeadHorizonTrackingComponent,
  ],
  imports: [
    NoResponseBlockedDialogComponent,
    CloseSuggestionBannerComponent,
    FeatureFlagModule,
    CommonModule,
    CommonSharedModule,
    PipeDirectiveModule,
    FullCalendarModule,
    CreateTaskModule,
    EditTaskModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    GenaricNotesModule,
    LeadPrimeNgModule,
    HistoryModule,
    GoogleAddressModule,
    ReorderPipeModule,
    ReMultipleSelectModule,
    ReMultiselectModule,
    RadioButtonModule,
    MenuModule,
    AmTimeAgoModule,
    MobileFormatPipeModule,
    PossibleDuplicateContactModule,
    LinkedContactSummaryModule,
    HelpLeadsUiModule,
    DuplicateLeadMergeModule,
    ExternalEoiGenerateModalModule,
    ExternalEoiLinksModule,
    HorizonHeatMapComponent,
    HorizonMatrixHeatmapComponent,
    HorizonBuyerInsightsComponent,
    HorizonSharedWithBuyerComponent,
    HorizonBuyerPreferencesComponent,
  ],
  exports: [
    EditLeadDetailComponent,
    EditLeadAppointmentComponent,
    LeadFollowUpPopoverComponent,
    LeadReportNotesSummaryComponent,
    LeadHorizonTrackingComponent,
  ],
})
export class EditLeadModule {}
